import {  registerBlockType } from "@wordpress/blocks";

// Just a way to wrap elements without producing any wrapper markup
import {
    Fragment,
    RawHTML
} from "@wordpress/element";

// Components contain several reusable React components
import { TextControl } from "@wordpress/components";

import { __ } from '@wordpress/i18n';

import "./style.scss";

registerBlockType("eelvnewsletter/reply", {
  title: __("Newsletter reply link"),
  icon: "format-chat",
  category: "common",
  attributes: {
    rep: {
      type: "string",
    },
    val: {
      type: "string",
    }
  },

  edit({ className, attributes, setAttributes, isSelected }) {
    const { rep, val } = attributes;

    const updateRep = rep => setAttributes({ rep });
    const updateVal = val => setAttributes({ val });

    return (
        <div className={className}>
          <span className={className+'-title'}>{val || (<em>{__('Displayed Label')}</em>)}</span>
          {isSelected && (
            <div>
            <TextControl
              className="rep"
              value={rep}
              onChange={updateRep}
              placeholder={__('Transmitted Value')}
              label={__('Transmitted Value')}
            />
            <TextControl
            className="val"
            value={val}
            onChange={updateVal}
            placeholder={__('Displayed Label')}
            label={__('Displayed Label')}
            />
            </div>
          )}
        </div>

    );
  },

  save({ attributes }) {
    const { rep, val } = attributes;
    return (
        <RawHTML>{'[nl_reply_link rep="'+rep+'" val="'+val+'"]'}</RawHTML>
    );
  }
});



// WEBPACK FOOTER //
// ./blocks/reply/index.js